module.exports = __webpack_public_path__ + "static/img/方程豹 豹8.13d94fa9.png";